import { apiBlog } from "@/api/blog.api.ts";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { BlogPostEditForm } from "@/pages/blog/edit/components/BlogPostEditForm.tsx";
import { BlogPostEditPreview } from "@/pages/blog/edit/components/BlogPostEditPreview.tsx";
import { BlogPostEditSettings } from "@/pages/blog/edit/components/BlogPostEditSettings.tsx";
import { ApiBlogPost, BlogEditContext, BlogEditSteps } from "@/types/blog.types.ts";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export function BlogPostEditPage() {
  const { id: postId } = useParams();
  const [step, setStep] = useState<BlogEditSteps>(BlogEditSteps.form);
  const [withoutImage, setWithoutImage] = useState<boolean>(false);
  const [post, setPost] = useState<ApiBlogPost | undefined>();
  const [fileId, setFileId] = useState<number>();
  const temporaryFileUuidsRef = useRef<string[]>([]);
  const { t } = useTranslation();

  const registerTemporaryFile = (fileUuid: string) => {
    temporaryFileUuidsRef.current = [...temporaryFileUuidsRef.current, fileUuid];
  };

  const unregisterTemporaryFile = (fileUuid: string) => {
    temporaryFileUuidsRef.current = temporaryFileUuidsRef.current.filter(
      (uuid) => uuid !== fileUuid
    );
  };

  const isTemporaryFile = (fileUuid: string) => temporaryFileUuidsRef.current.includes(fileUuid);

  const clearAttachmentTracking = () => {
    temporaryFileUuidsRef.current = [];
  };

  useEffect(
    () => () => {
      temporaryFileUuidsRef.current.forEach((fileUuid) => {
        void apiBlog.deleteAttachment(fileUuid);
      });
    },
    []
  );

  const contextValue = {
    step,
    setStep,
    setPost,
    post,
    postId,
    fileId,
    setFileId,
    withoutImage,
    setWithoutImage,
    registerTemporaryFile,
    unregisterTemporaryFile,
    isTemporaryFile,
    clearAttachmentTracking,
  };
  useTitle(t("blog:editing_post"), t("blog:blog"));

  return (
    <BlogEditContext.Provider value={contextValue}>
      {step == BlogEditSteps.form && <BlogPostEditForm />}
      {step == BlogEditSteps.preview && <BlogPostEditPreview />}
      {step == BlogEditSteps.settings && <BlogPostEditSettings />}
    </BlogEditContext.Provider>
  );
}
